// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-avatar-PKKWne{margin-bottom:24px}.edit-profile-Ij6Gny .coz-icon-button-mini{line-height:1}.edit-profile-Ij6Gny .coz-typography{color:rgba(var(--coze-fg-3),var(--coze-fg-3-alpha))}.label-wrap-ejhY3L{justify-content:flex-start;align-self:flex-start;align-items:center;gap:16px;width:100%;margin-bottom:20px;display:flex}.label-QnKqOS{width:76px;margin-bottom:0;font-size:12px;font-weight:500;line-height:16px}.submit-v3XnWF{width:100%;margin-top:48px}.count-cZ6U8j{color:#737577;margin:0 12px 0 8px;font-size:12px;line-height:16px}.upload-button-lPcyvz{font-size:12px;line-height:16px}.upload-button-lPcyvz a{color:var(--light-usage-primary-color-primary,#0077fa);font-weight:400}.filed-readonly-YOi2y9{align-items:center;width:100%;display:flex}.filed-readonly-YOi2y9 .text-EweipQ{line-height:20px}.filed-readonly-YOi2y9>button>button:last-child,.filed-readonly-YOi2y9>button>span:last-child{margin-left:4px}.field-edit-Ux2bRL{align-items:flex-start;width:100%;display:flex}.field-edit-Ux2bRL .field-edit-children-ej1QSf{flex:1}.field-edit-Ux2bRL .field-btn-FpBgPL{align-self:end}.field-edit-Ux2bRL .btn-nd94Jo{margin-left:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"update-avatar": `update-avatar-PKKWne`,
	"updateAvatar": `update-avatar-PKKWne`,
	"edit-profile": `edit-profile-Ij6Gny`,
	"editProfile": `edit-profile-Ij6Gny`,
	"label-wrap": `label-wrap-ejhY3L`,
	"labelWrap": `label-wrap-ejhY3L`,
	"label": `label-QnKqOS`,
	"submit": `submit-v3XnWF`,
	"count": `count-cZ6U8j`,
	"upload-button": `upload-button-lPcyvz`,
	"uploadButton": `upload-button-lPcyvz`,
	"filed-readonly": `filed-readonly-YOi2y9`,
	"filedReadonly": `filed-readonly-YOi2y9`,
	"text": `text-EweipQ`,
	"field-edit": `field-edit-Ux2bRL`,
	"fieldEdit": `field-edit-Ux2bRL`,
	"field-edit-children": `field-edit-children-ej1QSf`,
	"fieldEditChildren": `field-edit-children-ej1QSf`,
	"field-btn": `field-btn-FpBgPL`,
	"fieldBtn": `field-btn-FpBgPL`,
	"btn": `btn-nd94Jo`
};
export default ___CSS_LOADER_EXPORT___;
